// extracted by mini-css-extract-plugin
export default {"radioLabel":"RadioStorageSizeBtn_radioLabel__ow5ni"};